import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useEffect, useRef, useState } from "react";
import { DossierItemType } from "dto/Dossier/DossierItemType";
import Popper from "components/Popper";
import { ITag, TagType } from "dto/ITag";
import classNames from "classnames";
import TagBadge from "components/TagBadge";
import tagsService from "api/tagsService";
import ChooseTagNew from "components/ChooseTagNew";
import { Tooltip } from "@mui/material";
import { gridRowsLookupSelector } from "@mui/x-data-grid-premium";
import { IDossierItem } from "dto/Dossier/IDossierItem";
import { useTranslation } from "react-i18next";

const TagCell: FC<Props> = ({ element, tags, apiRef }) => {
  const { t } = useTranslation();
  const refTag = useRef(null);
  const { mutate: removeTag } = tagsService.useRemoveTagFromPackage();
  const [showTagsSmall, setShowTagsSmall] = useState(false);

  const [findedTags, setFindedTags] = useState<ITag[]>(
    tags?.filter((tag) => element?.TagIds?.find((iTag) => tag.Id === iTag))
  );

  useEffect(() => {
    const filteredTags = tags?.filter((tag) =>
      element?.TagIds?.find((iTag) => tag.Id === iTag)
    );

    setFindedTags(filteredTags);
  }, [element?.TagIds, tags]);

  const handleUpdateTags = (tags: ITag[]) => {
    const rows = Object.values(
      gridRowsLookupSelector(apiRef)
    ) as IDossierItem[];
    apiRef.current.dataSource.cache.clear();
    const toUpdate = rows.find((x) => x.DossierId === element.DossierId);

    if (toUpdate) {
      toUpdate.TagIds = tags.map((t) => t.Id);

      setFindedTags(
        tags?.filter((tag) => toUpdate?.TagIds?.find((iTag) => tag.Id === iTag))
      );
      //apiRef.current.setRows(rows);
      //apiRef.current.updateRows([toUpdate]);
    }

    // let files = [...dossierFiles];

    // let el = files.find((c) => c.Id === element.Id && c.Kind === element.Kind);

    // if (el) {
    //   el.TagIds =
    // }

    // setDossierFiles(files);
  };

  const handleRemoveTag = (tag: ITag) => {
    removeTag(
      {
        Items: [{ Id: element.Id, Kind: element.Kind }],
        TagId: tag.Id,
      },
      {
        onSuccess: () => {
          setFindedTags(findedTags.filter((ftag) => ftag.Id !== tag.Id));
        },
      }
    );
  };

  if (element.Type === DossierItemType.Folder) {
    return <></>;
  }

  return (
    <div
      className={classNames(
        styles.tags,
        findedTags && findedTags.length > 0 ? styles.notEmpty : styles.empty
      )}
      ref={refTag}
    >
      {findedTags && findedTags.length > 0 && (
        <div
          onClick={(e) => {
            setShowTagsSmall(!showTagsSmall);
            e.preventDefault();
            e.stopPropagation();
          }}
          key={`tag_${element.Id}_${findedTags[0].Id}`}
        >
          <TagBadge
            onRemove={(tag) => handleRemoveTag(tag)}
            tag={findedTags[0]}
          />
        </div>
      )}
      {findedTags && findedTags.length > 1 && (
        <div
          className={styles.moreTags}
          onClick={(e) => {
            setShowTagsSmall(!showTagsSmall);
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          +{findedTags.length - 1}
        </div>
      )}

      {findedTags && findedTags.length === 0 && (
        <Tooltip title={t("common.setLabel")}>
          <div>
            <div
              className={styles.fakeBadge}
              onClick={(e) => {
                setShowTagsSmall(!showTagsSmall);
                e.stopPropagation();
              }}
            >
              ...
            </div>
          </div>
        </Tooltip>
      )}

      {showTagsSmall && (
        <Popper
          anchorEl={refTag?.current}
          open={showTagsSmall}
          setOpen={setShowTagsSmall}
        >
          <ChooseTagNew
            toggle={setShowTagsSmall}
            updateTags={handleUpdateTags}
            type={
              element.IsTemplate ? TagType.Templates : TagType.EditorDocuments
            }
            //@ts-ignore
            toTag={element as IPackage}
          />
        </Popper>
      )}
    </div>
  );
};

export default TagCell;
